export default {"src":"/_next/static/media/icon-marketplace-planet-items.c0849551.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};